import React, { useState } from "react";
import { askForPremium } from '../../api/parentCoach';

export default function PremiumModal({ isOpen, onClose, askedForPremium, onUpdateUser, context, reason }) {
  const [isLoading, setIsLoading] = useState(false);
  const [justSent, setJustSent] = useState(false);

  if (!isOpen) return null;

  const handleAskParents = async () => {
    setIsLoading(true);
    try {
      const updatedUser = await askForPremium(reason);
      onUpdateUser(updatedUser);
      setJustSent(true);
    } catch (error) {
      console.error('Erreur lors de la demande premium:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setJustSent(false);
    onClose();
  };

  // Vue "Demande envoyée" (après envoi ou si déjà demandé)
  if (justSent || askedForPremium) {
    return (
      <div
        className="absolute inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
        onClick={handleClose}
      >
        <div
          className="bg-slate-900 rounded-2xl p-6 max-w-sm w-full border-2 border-dashed border-emerald-500/50"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Icône de succès */}
          <div className="text-center mb-4">
            <span className="text-5xl">✅</span>
          </div>

          {/* Titre */}
          <h2 className="text-white text-xl font-bold text-center mb-2">
            Demande envoyée !
          </h2>
          <p className="text-gray-400 text-sm text-center mb-5">
            Tes parents ont reçu ta demande. Ils pourront activer ton accès Premium depuis leur espace.
          </p>

          {/* CTA Fermer */}
          <button
            onClick={handleClose}
            className="w-full py-3 px-4 bg-emerald-500 hover:bg-emerald-400 disabled:bg-amber-500/50 text-slate-900 font-semibold rounded-xl transition-colors mb-3"
          >
            Compris !
          </button>
          {/* Lien secondaire */}
          <button
            onClick={handleClose}
            className="w-full text-gray-500 hover:text-gray-400 text-sm transition-colors"
          >
            Fermer
          </button>
        </div>
      </div>
    );
  }

  // Vue par défaut "Demander Premium"
  return (
    <div
      className="absolute inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={handleClose}
    >
      <div
        className="bg-slate-900 rounded-2xl p-6 max-w-sm w-full border-2 border-dashed border-amber-500/50"
        style={{ boxShadow: '0 0 30px rgba(245, 158, 11, 0.1)' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Titre */}
        <h2 className="text-white text-xl font-bold text-center mb-2">
          Passe à ORIA Premium ?
        </h2>
        <p className="text-gray-400 text-sm text-center mb-5">
          {context}
        </p>

        {/* Encart des bénéfices */}
        <div className="bg-slate-800/50 rounded-xl p-4 mb-5 border border-slate-700">
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <span className="text-lg">👥</span>
              <span className="text-gray-300 text-sm">450+ professionnels à rencontrer</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg">💎</span>
              <span className="text-gray-300 text-sm">4 questionnaires pour mieux te connaître</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg">✨</span>
              <span className="text-gray-300 text-sm">Analyse personnalisée par métier</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg">💬</span>
              <span className="text-gray-300 text-sm">Conversations illimitées</span>
            </div>
          </div>
        </div>

        {/* CTA Principal */}
        <button
          onClick={handleAskParents}
          disabled={isLoading}
          className="w-full py-3 px-4 bg-amber-500 hover:bg-amber-400 disabled:bg-amber-500/50 text-slate-900 font-semibold rounded-xl transition-colors mb-3"
        >
          {isLoading ? 'Envoi en cours...' : 'Demander à mes parents'}
        </button>

        {/* Lien secondaire */}
        <button
          onClick={handleClose}
          className="w-full text-gray-500 hover:text-gray-400 text-sm transition-colors"
        >
          Pas maintenant
        </button>
      </div>
    </div>
  );
}
